'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var LocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? colors.grey[50] : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        React__default.createElement("path", { d: 'M12.0003 0.47998C7.76656 0.47998 4.32031 3.92623 4.32031 8.15998C4.32031 14.9344 11.3422 23.0137 11.6403 23.355C11.7322 23.46 11.8616 23.52 12.0003 23.52C12.1484 23.5106 12.2684 23.46 12.3603 23.355C12.6584 23.0081 19.6803 14.79 19.6803 8.15998C19.6803 3.92623 16.2341 0.47998 12.0003 0.47998ZM12.0003 5.75998C13.5903 5.75998 14.8803 7.04998 14.8803 8.63998C14.8803 10.23 13.5903 11.52 12.0003 11.52C10.4103 11.52 9.12031 10.23 9.12031 8.63998C9.12031 7.04998 10.4103 5.75998 12.0003 5.75998Z', fill: color })));
};
var LocationIcon$1 = React__default.memo(LocationIcon);

export { LocationIcon$1 as default };
//# sourceMappingURL=Location.js.map
